var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.792 2.027L10.25 11.5.792 20.973 2.818 23l11.5-11.5L2.819 0 .792 2.027z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAxNSAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuNzkxNjA3IDIuMDI2ODhMMTAuMjUwNCAxMS41TDAuNzkxNjA3IDIwLjk3MzFMMi44MTg0OCAyM0wxNC4zMTg1IDExLjVMMi44MTg0OCA0Ljc2ODM3ZS0wN0wwLjc5MTYwNyAyLjAyNjg4WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgForwardArrow as ReactComponent };